import Vue from "vue";
import Vuex from "vuex";
import bridge from "./module/bridge";
import products from "./module/products";
import NProgress from "nprogress";
import "nprogress/nprogress.css"; // progress bar style

NProgress.configure({ showSpinner: false }); // NProgress Configuration

import {
  LOAD_NOTIFICATIONS,
  FLAG_LOADING,
  SAVE_DATA_USER,
} from "./mutation-types";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    notifications: {},
    flagLoading: false,
    $listUser: [],
  },
  getters: {
    notifications: (state) => state.notifications,
    flagLoading: (state) => state.flagLoading,
    $listUser: (state) => state.$listUser,
  },
  mutations: {
    LOAD_NOTIFICATIONS(state, payload) {
      state.notifications = payload;
    },
    FLAG_LOADING(state, payload) {
      state.flagLoading = payload;
      if (payload) NProgress.start();
      else NProgress.done();
      setTimeout(() => {
        NProgress.done();
        state.flagLoading = false;
      }, 30000);
    },
    SAVE_DATA_USER(state, payload) {
      state.$listUser = payload;
    },
  },
  actions: {
    LOAD_NOTIFICATIONS({ commit, dispatch }, payload) {
      commit(LOAD_NOTIFICATIONS, payload);
    },
    FLAG_LOADING({ commit, dispatch }, payload) {
      commit(FLAG_LOADING, payload);
    },
    SAVE_DATA_USER({ commit, dispatch }, payload) {
      commit(SAVE_DATA_USER, payload);
    },
  },

  modules: {
    bridge,
    products,
  },
});
